export const Specs = {
  AnonymousCart: 'specs.premium.AnonymousCart',
  AnonymousCartBusinessEmail: 'specs.premium.AnonymousCartBusinessEmail',
  StorefrontResultsPageHeader: 'specs.premium.StorefrontResultsPageHeader',
  LoggedInMobileGate: 'specs.premium.domains.LoggedInMobileGate',
  LoggedInMobileConnectExperiment: 'loggedInMobileConnectAndAssignDomains',
  PricingPerceptionFirstYear: 'domainsPricingPerceptionFirstYear',
  PricingPerceptionSplitPage: 'domainsPricingPerceptionSplitPage',
  FunnelUxFixes: 'funnelUxFixes',
} as const;

export type TSpecs = (typeof Specs)[keyof typeof Specs];

export type TSpecsExperiments = Record<TSpecs, boolean | string>;
